import axios from 'axios'; 
import router from '@/router/index.js' 
import { useMessage } from '@/utils/message.js'
import { useStorage } from '@/utils/storage.js'

const instance = axios.create({
	withCredentials: true,
    // 注意！！！
    // 这里是全局统一加上了 '/dev-api' 前缀，
    // 也就是说所有接口都会加上'/dev-api'前缀在，
    // 页面里面写接口的时候就不要加 '/dev-api'了
    baseURL: import.meta.env.VITE_APP_API_BASE,
    timeout: 30000
})

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
	const token = useStorage('local').get('user-token')
	if(token) {
		config.headers['TOKEN'] = token
	}
	
    // 在发送请求之前做些什么
    return config;
}, function (err) {
    // 对请求错误做些什么
	useMessage(`${err.message || '接口错误，未知异常！'}`).notify('error', '错误提示')
	return Promise.resolve(err)
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
	const { status, data } = response
	
	if(status !== 200) {
		useMessage('服务器响应错误！').notify('error', '错误提示')
		return { code: -1 }
	}
	
	//如果 response 有该标记，下载文件
	if(response.headers['content-disposition']) {
		const attachInfo = response.headers['content-disposition'].split(';');
		const filename = attachInfo.reduce((res, itm) => {
			if(itm.startsWith('filename=')) {
				return itm.split('filename=')[1].replace(/['"]/g, '');
			}
			return res;
		}, '')
		return { data, filename }
	}
	
	//账号被他人登录，被迫下线，未登录，跳转到登录页面 
	// 403 未登录/失效, 499 账号在其他地方登录
	if(data.code == 403 || data.code == 499) {
		// 清空数据
		useStorage('local').clear()
		useMessage(`您的${data.code == 403 ? ' TOKEN 已失效':'账号在其他地方登录'}，请重新登录`).alert().then(()=>{
			document.location.reload()
		}) 
		return data
	}
	
	if(data.code !== 0) {
		useMessage(data.message || '接口错误，数据返回异常！').notify('error', '错误提示')
	}
	
	return data
}, function (err) {
    // 对响应错误做点什么
	useMessage(err.message || '接口错误，未知异常！').notify('error', '错误提示')
	return Promise.reject(err)
});

const request = (method, url, data, options) => {
	const { headers, responseType = 'json' } = options || {}
	
	const axiosOpts = { method, url, data, responseType }
	// 如果是get，参数是params 
	if(method === 'get') {
		axiosOpts['params'] = data
	}
	
	if(headers) {
		axiosOpts['headers'] = headers
	}
	
	return instance.request(axiosOpts)
}

export const get = (path, params, options) => {
	return request('get', path, params, options)
}
export const post = (path, data, options) => {
	return request('post', path, data, options)
}
export const put = (path, data, options) => {
	return request('put', path, data, options)
}
export const remove = (path, data, options) => {
	return request('delete', path, data, options)
}
export const patch = (path, data, options) => {
	return request('patch', path, data, options)
}

export const useRequest = (module, options) => {
	const base = `${module}/`;
	options = options || {};
	
	return {
		post(path, data) {
			return post(base + path, data, options);
		},
		get(path, data) {
			return get(base + path, data, options);
		},
		put(path, data) {
			return put(base + path, data, options);
		},
		remove(path, data) {
			return remove(base + path, data, options);
		},
		patch(path, data) {
			return patch(base + path, data, options);
		}
	}
}